import script from "./PreviewButtongroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewButtongroup.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewButtongroup.vue?vue&type=style&index=0&id=03fc2ac5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03fc2ac5"]])

export default __exports__